import React, { useState } from 'react';
import logo from '../../assets/images/footer-logo.svg';
import mobileLogo from '../../assets/images/apptitude-logo-new-mobile.svg';
import './assets/styles/navigation-list.scss';
import hamburgerIcon from '../../assets/mobile/hamburger.svg';
import { Link } from '@reach/router';
import Drawer from '../Drawer';
import useResponsive from '../../effects/useResponsive';

function NavigationList({ children, path }) {
  const isRoot = path['*'] === '/';
  const className = !isRoot ? 'other-page' : '';
  const [visible, setVisible] = useState(false);
  const { isMobile } = useResponsive();
  const locations = [
    [
      {
        key: 'logo-web',
        name: 'homepage',
        route: '/',
        type: 'img',
        props: {
          src: logo,
          alt: 'Apptitude',
          id: 'left-nav-logo',
          style: { height: 90 },
        },
      },
      {
        key: 'logo-mobile',
        name: 'homepage',
        route: '/',
        type: 'img',
        props: {
          src: mobileLogo,
          alt: 'Apptitude',
          id: 'left-nav-logo-mobile',
          style: { height:41 }
        },
      },
      { key: 'courses-route', name: 'courses', route: 'courses' },
      {
        key: 'partners-route',
        name: 'partners',
        route: 'education_partners',
      },
      // { key: 'events-route', name: 'events', route: '//apptitude.xyz/events/' },
    ],
    [
      { key: 'login-route', name: 'login', route: '//apptitude.xyz/login' },
      {
        key: 'signup-web',
        name: 'sign up',
        route: '//apptitude.xyz/login',
        type: 'button',
        src: hamburgerIcon,
      },
      {
        key: 'signup-mobile',
        name: 'sign up',
        route: '//apptitude.xyz/login',
        type: 'img',
        props: { src: hamburgerIcon },
      },
    ],
  ];

  const [navlinks, registrationlinks] = locations;

  function mapLinks(link, index) {
    function handleLinkRender(linkType) {
      switch (linkType) {
        case 'img':
          return <img alt="" {...link.props} draggable={false} />;

        case 'button':
          return <button {...link.props}>{link.name}</button>;

        default:
          return link.name;
      }
    }
    return (
      <Link key={link.key} to={link.route} onClick={handleClick(link.key)}>
        {handleLinkRender(link.type)}
      </Link>
    );
  }

  function mapExternalLinks(link, index) {
    function handleLinkRender(linkType) {
      switch (linkType) {
        case 'img':
          return <img alt="" {...link.props} draggable={false} />;

        case 'button':
          return <button {...link.props}>{link.name}</button>;

        default:
          return link.name;
      }
    }
    return (
      <a key={link.key} href={link.route} onClick={handleClick(link.key)}>
        {handleLinkRender(link.type)}
      </a>
    );
  }

  // function styles() {
  //   switch (pathname) {
  //     case '/':
  //       return { height: 684 };
  //     default:
  //       return { height: 'auto' };
  //   }
  // }

  function handleClick(key) {
    return function(event) {
      if (key === 'signup-mobile') {
        event.preventDefault();
        return setVisible(true);
      }
      return setVisible(false);
    };
  }

  return (
    <>
      <div id="navigation-list" className={className}>
        <div className="container">
          <div id="left-nav">{navlinks.map(mapLinks)}</div>
          <div id="right-nav">{registrationlinks.map(mapExternalLinks)}</div>
        </div>
        {children}
        {isMobile && (
          <Drawer visible={visible} onClose={() => setVisible(false)} />
        )}
      </div>
    </>
  );
}

export default NavigationList;
